// src/JsonHighlight.js
import React from "react";

/**
 * JsonHighlight - Syntax highlighting for JSON
 *
 * Colorizes JSON strings, numbers, booleans, null, keys, and punctuation
 */
const JsonHighlight = ({ data }) => {
  const syntaxHighlight = (json) => {
    if (typeof json !== "string") {
      json = JSON.stringify(json, null, 2);
    }

    json = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

    return json.replace(
      /("(\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
      (match) => {
        let cls = "json-number";
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = "json-key";
          } else {
            cls = "json-string";
          }
        } else if (/true|false/.test(match)) {
          cls = "json-boolean";
        } else if (/null/.test(match)) {
          cls = "json-null";
        }
        return '<span class="' + cls + '">' + match + "</span>";
      }
    );
  };

  return (
    <pre
      style={{ textAlign: "left" }}
      dangerouslySetInnerHTML={{ __html: syntaxHighlight(data) }}
    />
  );
};

export default JsonHighlight;
